import '../assets/css/header.css';
import { MdAccountCircle,MdMenu,MdLogout,MdSupervisedUserCircle } from "react-icons/md";
import { BrowserRouter as Router, Routes, Link, Route,Redirect,Navigate,useNavigate,useLocation, useHistory  } from 'react-router-dom';
import { Button } from 'primereact/button';
import React, { useContext,useEffect,useRef, useState } from 'react';
import MyContext from '../contextapi/MyContext';
import { Menubar } from 'primereact/menubar';
import {userService} from '../services/authentication';
import { Menu } from 'primereact/menu';
import axios from 'axios';
// import axios from 'axios';



const Header = () => {
    const mycontext = useContext(MyContext);
    const [fillbtn,setfillbtn] = useState(true);
    const [userdatadetails,setuserdatadetails] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    
    

    
    const toggleSidebar = () =>{
        if(mycontext.value !== 'sidebar-box'){
            mycontext.openSidebar('sidebar-box');
            mycontext.contentBox('content-box');   
        }else{
            mycontext.openSidebar('sidebar-box-inner');
            mycontext.contentBox('content-box-full');
        } 
    }
    const logout = () =>{
        userService.logout().then((response)=>{
            if(response.status == 200 && response.data.success == true){
                mycontext.updateuserloggedinstatus(false);
                // Navigate('/');
                window.location.href = '/';
            }
        }); 
    } 

    const oldtimesheet = ()=>{
        navigate('/resetpassword');
    }

    useEffect(() => {
        if(!userdatadetails){
            setuserdata();
            setfillbtn(false);
        }
        // pathchecker();
    },[]);


    const setuserdata = () =>{
        const userData = JSON.parse(localStorage.getItem('user')) != undefined ? JSON.parse(localStorage.getItem('user')) : {'name':''};
        mycontext.setUserdata(userData.name); 
        mycontext.getGreeting(); 
        setuserdatadetails(true);
    }
  
    const menuRight = useRef(null);
    const items = [
        {
            label: <Button label="Profile" text/>,
            icon: <MdSupervisedUserCircle />,
        },
        {
            label: <Button label="Update Password" text onClick={oldtimesheet}/>,
            icon: <MdLogout/>
        },
        {
            label: <Button label="Logout" text onClick={logout}/>,
            icon: <MdLogout/>
        },
        
        {
            separator: true
        },
     ];

     const fill_timesheet_btn = {
        backgroundColor: 'rgb(68, 68, 68)',
        color: 'rgb(255, 255, 255)',
        border: '1px solid rgb(68, 68, 68)',
        borderRadius: '8px',
      };

      const timesheet_btn = {
        backgroundColor: "#D9D9D9",
        border: "1px solid #D9D9D9",
        borderRadius: "50%",
        color: "#fff",
      };

     console.log('Current URL:', location.pathname);

    return (
        <>
            <div class="navbar navbar-expand-lg navbar-light bg-light navbar-style-custom">
                <div className='menu-wrap-style'>
                    <div className='menu-style-outer' onClick={toggleSidebar}>
                     <MdMenu className='menuicon-style'/>
                    </div> 
                    <div className='menu-content-cont-style'>
                      <p>{mycontext.greeting}</p>
                      <a class="navbar-brand" href="#">{mycontext.username}</a>
                    </div>
                </div>
                <div>
                    <ul class="navbar-nav">
                  
                        <li class="nav-item active" style={{paddingright: '21px'}}>
                            {location.pathname == '/dashboard' || location.pathname == '/' ? (<Button label="Fill Timesheet" style={fill_timesheet_btn} severity="success" outlined onClick={() => mycontext.addtimesheettogglefun(true)}/>): (<></>) }
                            
                            {/* <a class="nav-link" href="#">{mycontext.username} <span class="sr-only"></span></a> */}
                        </li>
                        <li> </li>
                        <Button label="" icon={<MdAccountCircle/>} style={timesheet_btn} className="mr-2" onClick={(event) => menuRight.current.toggle(event)} aria-controls="popup_menu_right" aria-haspopup />
                        <Menu model={items} popup ref={menuRight}/>
                        {/* <Menubar model={items}/> */}
                        
                        {/* <li class="nav-item">
                            <a class="nav-link" href="#"><MdAccountCircle/></a>
                        </li> */}
                        
                    </ul>
                </div>
            </div>
        </>
    );
}

export default Header;